import PropTypes from 'prop-types';
import { renderChildren } from '@blaze-cms/react-page-builder';
import { CONTEXTS } from './constants';

const StickyRow = ({ children, context }) => {
  const parsedChildren = (((children || {}).props || {}).children || [])[1] || [];
  if (!parsedChildren.length) return null;

  return (
    <>
      <div className="sticky-row__below-fold">{renderChildren(children)}</div>

      <div className="sticky-row__above-fold-wrapper">
        <div className={`sticky-row__above-fold sticky-row__above-fold--${context}`}>
          {renderChildren(children)}
        </div>
      </div>
    </>
  );
};

StickyRow.propTypes = {
  context: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

StickyRow.defaultProps = {
  context: CONTEXTS.ARTICLE
};

export default StickyRow;
